module.exports = __webpack_public_path__ + "static/media/assi.4f172bc6.png";